import { Injectable } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { api } from '../api';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Storage } from '../constants';
import 'rxjs/add/operator/publishReplay';
import { BrandingService } from '../branding/branding.service';

@Injectable()
export class SitemapService {
  sitemapData;
  private eventRaiser = new Subject<boolean>();
  eventRaiser$ = this.eventRaiser.asObservable();
  constructor(
    private http: HttpClient,
    private locationStrategy: LocationStrategy,
    private brandingService: BrandingService) { }

  getPublicNodes() {
    return this.http.get(api.public.sitemap.SITEMAP_NODES)
      .catch(this.handleError);
  }

  getSitemapNodes() {
    if (window.localStorage.getItem(Storage.AUTH_TOKEN)) {
      if (!this.sitemapData) {
        this.sitemapData = this.http.get(api.sitemap.SITEMAP_NODES)
          .publishReplay(1)
          .refCount()
          .catch(this.handleError);
      }
      return this.sitemapData;
    } else {
      return Observable.of(JSON.parse(window.localStorage.getItem(Storage.PUBLIC_SITEMAP)) || [])
        .catch(this.handleError);
    }
  }

  setPublicSitemap() {
    const setPublicSitemapCompleteResponse = new Subject<boolean>();
    this.getPublicNodes().subscribe(
      (res) => {
        const pages = res as any[];
        const removeIndexes = [];
        let counter = 0;
        pages.forEach((element, index) => {
          if (element.nodeKey === 'menu_landing_rec_jobs_alert' || element.nodeKey === 'menu_landing_rec_jobs_near_me'
          || element.nodeKey === 'menu_landing_rec_signin') {
                removeIndexes.push(index);
              }
            });

        removeIndexes.forEach((element, index) => {
          pages.splice(element - counter, 1);
          counter++;
        });

        window.localStorage.setItem(Storage.PUBLIC_SITEMAP, JSON.stringify(pages));
        setPublicSitemapCompleteResponse.next(true);
      }
    );
    return setPublicSitemapCompleteResponse;
  }

  updateSitemapData() {
    this.sitemapData = null;
    this.eventRaiser.next(true);
  }

  private handleError(error: any) {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  removeAuthToken() {
    window.localStorage.removeItem(Storage.AUTH_TOKEN);
  }

  removeJobApplyObject() {
    if (window.localStorage.getItem('jobApplyObject') != null) {
      window.localStorage.removeItem('jobApplyObject');
    }
  }

  signout() {
    // TODO: call SSO Broker service to kill any session on server.
    // Also refactor and add this method to appropriate service
    this.removeAuthToken();
    this.removeJobApplyObject();
    window.location.href = this.locationStrategy.getBaseHref();
  }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/sitemap/sitemap.service.ts